export const ToastWarningIcon = () => {
  return (
    <div className="flex h-4 w-4 items-center justify-center rounded-full bg-yellow-500 text-center text-xs font-semibold text-white dark:text-black">
      !
    </div>
  )
}
